module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-category-list row column"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.categories), function(category, index) {
    return _c('div', {
      staticClass: "column small-12 large-4 category",
      class: {
        active: _vm.activeIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.setSearch(index)
        }
      }
    }, [_c('div', {
      staticClass: "inner-content card text-center"
    }, [_c('div', {
      staticClass: "row p-1"
    }, [(_vm.activeIndex === index) ? _c('div', {
      staticClass: "column shrink"
    }, [_c('dropdown', {
      key: ((_vm.$options.name) + "_" + index),
      attrs: {
        "icon": "fa fa-ellipsis-v fa-2x action",
        "position": "bottom"
      }
    }, [_c('div', {
      staticClass: "dropdown-buttons"
    }, [_c('edit-vehicle-category', {
      attrs: {
        "item": category
      }
    }), _c('ActionButton', {
      attrs: {
        "action": _vm.deleteCategory,
        "confirm": true
      }
    }, [_vm._v("Delete")]), _c('requirement-modal', {
      attrs: {
        "entity_id": category.id,
        "entity_type": "VehicleCategory"
      }
    })], 1)])], 1) : _vm._e(), _c('div', {
      staticClass: "column text-left"
    }, [_c('small', [_vm._v("C" + _vm._s(category.id))]), _c('h2', [_vm._v(_vm._s(category.name))])])])])])
  }), 0), _c('div', {
    staticClass: "row column"
  }, [_c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dadc056e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CategoryList.vue
// module id = 2553
// module chunks = 1